module.exports = __webpack_public_path__ + "img/5.61102e62.png";